module.exports = {
	"ff_all_asset": 43276003193,
	"oil_majors": [
		8191395187,
		0.18928261813986041,
		[
			[
				"Exxon Mobil",
				3292437692
			],
			[
				"Chevron",
				1628276114
			],
			[
				"Shell",
				870913744
			],
			[
				"ConocoPhillips",
				814189482
			],
			[
				"TotalEnergies",
				550082400
			],
			[
				"BP",
				329518488
			],
			[
				"Phillips 66",
				307719315
			],
			[
				"Valero Energy",
				263156389
			],
			[
				"Eni",
				135101563
			]
		]
	],
	"og": [
		17322625523,
		0.400282471690962,
		[
			[
				"Exxon Mobil",
				3292437692
			],
			[
				"Chevron",
				1628276114
			],
			[
				"Shell",
				870913744
			],
			[
				"ConocoPhillips",
				814189482
			],
			[
				"Cheniere Energy",
				787988248
			],
			[
				"TotalEnergies",
				550082400
			],
			[
				"Williams Companies",
				511234854
			],
			[
				"EOG Resources",
				444339256
			],
			[
				"ONEOK",
				364999426
			],
			[
				"Kinder Morgan",
				364159455
			]
		]
	],
	"ut": [
		11615689883,
		0.26840948853795416,
		[
			[
				"NextEra Energy",
				984794133
			],
			[
				"Southern",
				720928552
			],
			[
				"Duke Energy",
				678005947
			],
			[
				"Constellation Energy",
				500585309
			],
			[
				"American Electric Power",
				413353055
			],
			[
				"Exelon",
				337602565
			],
			[
				"Sempra",
				336830522
			],
			[
				"Dominion Energy",
				327089373
			],
			[
				"Vistra",
				315794526
			],
			[
				"National Grid",
				310191328
			]
		]
	],
	"other": [
		14337687787,
		0.331308039771084,
		[
			[
				"Berkshire Hathaway",
				6998819740
			],
			[
				"Siemens",
				764749015
			],
			[
				"GE Vernova",
				732610466
			],
			[
				"Blackstone",
				690281408
			],
			[
				"KKR",
				552353640
			],
			[
				"BHP Group",
				543451729
			],
			[
				"Ares Management",
				415785537
			],
			[
				"CSX",
				387601983
			],
			[
				"Mitsubishi",
				284936952
			],
			[
				"Mitsubishi Heavy Indus",
				275420119
			]
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/TspHoldingStats.json
// module id = 1013
// module chunks = 0